import { DashboardEventService } from './../../dashboard/dashboard-event.service';
import { IntradayLadderComponent } from './../intraday-ladder/intraday-ladder.component';
import { AppConfig } from './../../app.config';
import { GetSurvivalHorizonServiceDataOutput, SurvivalHorizonData } from '@liquitics/transaction';
import { Subscription } from 'rxjs';
import { FiveDayLadderSelection } from './../five-day-ladder/five-day-ladder-selection';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, ComponentFactoryResolver, Input } from '@angular/core';
import { SurvivalHorizonService } from '../survival-horizon.service';
import { ExplainComponent } from '../../explain/explain.component';

@Component({
    selector: 'app-multi-entity-nostro-details',
    templateUrl: './multi-entity-nostro-details.component.html',
    styleUrls: ['./multi-entity-nostro-details.component.scss']
})
export class MultiEntityNostroDetailsComponent implements OnInit, OnDestroy {
    initialized = false;
    nostroViewMode = 'INTRADAY';
    currency: string;
    inAmount: number;
    outAmount: number;
    recThroughputPercentage: number;
    payThroughputPercentage: number;
    private dataStreamDisposable: Subscription;
    subscription: Subscription;
    @ViewChild(IntradayLadderComponent, { static: true }) intradayLadderComponent: IntradayLadderComponent;
    @ViewChild(ExplainComponent, { static: true }) explainComponent: ExplainComponent;

    constructor(private survivalHorizonService: SurvivalHorizonService,
        private dashboardEventService: DashboardEventService,
        private appConfig: AppConfig) {

    }

    ngOnInit() {
        this.dataStreamDisposable = this.survivalHorizonService.getPollingDataSubject()
            .subscribe({
                next: (data: GetSurvivalHorizonServiceDataOutput) => {
                    this.updateDetails(data);
                }, error: (err) => {
                    console.log(err);
                    throw err;
                }
            });
        this.subscription = (this.dashboardEventService.currencySelectionSubject.subscribe({
            next: currency => {
                this.currency = currency;
                this.initialized = false;
                if (this.explainComponent) {
                    this.explainComponent.explain(this.currency, 0, this.appConfig.getTodayString());
                }
            }
        }));
    }

    ngOnDestroy() {
        if (this.dataStreamDisposable) {
            this.dataStreamDisposable.unsubscribe();
        }
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    private updateDetails(data: GetSurvivalHorizonServiceDataOutput) {
        this.inAmount = 0.0;
        this.outAmount = 0.0;
        if (this.currency) {
            if (data) {
                if (data.fiveDayLadder) {
                    data.fiveDayLadder
                        .filter((position: SurvivalHorizonData) => {
                            return position.bucket === this.appConfig.getTodayString() &&
                                position.currency === this.currency;
                        })
                        .forEach((position: any) => {
                            this.inAmount += position.inAmount;
                            this.outAmount += position.outAmount;
                        })
                        ;
                }
                if (data.throughput) {
                    this.recThroughputPercentage = data.throughput.actualRecAmount / data.throughput.actualRecAmount;
                    this.payThroughputPercentage = data.throughput.actualPayAmount / data.throughput.actualPayAmount;
                }
            }
        }
        if (this.intradayLadderComponent) {
            this.intradayLadderComponent.refreshData('USD');
        }
        this.initialized = true;
    }

    round(value: number): string {
        const rounded = Math.round(value);
        let formatted = String(rounded);
        if (rounded < 0) {
            formatted = '(' + formatted + ')';
        }
        return formatted;
    }

    onNostroViewModeChange(event) {
        this.nostroViewMode = event.value;
        if (this.explainComponent) {
            if (this.nostroViewMode === 'BY_PRODUCT_TYPE') {
                this.explainComponent.setByProductType();
                this.explainComponent.explain(this.currency, 0, this.appConfig.getTodayString());
            } else if (this.nostroViewMode === 'BY_CLIENT_GROUP') {
                this.explainComponent.setByClientGroup();
                this.explainComponent.explain(this.currency, 0, this.appConfig.getTodayString());
            } else if (this.nostroViewMode === 'INTRADAY') {

            }
        }
    }
}
